export default __webpack_public_path__ + "static/media/ic_pin_job.06c980bd.svg";